// src/screens/student/quizzestests/QuizzesTests.js
import React, { useContext, useEffect, useState } from 'react';
import '../../../assets/css/student/quizzesandtest/QuizzesAndTest.css';
import StudentLayout from '../../../layouts/student/studentlayout/StudentLayout';
import AppContext from '../../../context/AppContext';
import axios from 'axios';
import Swal from 'sweetalert2';

const QuizzesAndTest = () => {
  const { loggedInStudent, baseUrl } = useContext(AppContext);

  const [quizzes, setQuizzes] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [activeTab, setActiveTab] = useState('available');
  const [showQuizModal, setShowQuizModal] = useState(false);
  const [activeQuiz, setActiveQuiz] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [score, setScore] = useState(null);

  // Create Quiz Modal State
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createForm, setCreateForm] = useState({ title: '', subject: '' });
  const [createError, setCreateError] = useState('');
  const [sampleQuestions, setSampleQuestions] = useState([]);

  const viewAllSubjects = () => {
    axios.post(`${baseUrl}/admin/subject/viewAllSubjects`)
      .then((response) => {
        console.log(response.data.subjects);
        setSubjects(response.data.subjects);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const viewMyQuizzes = (student_id) => {
    console.log(student_id);
    axios.post(`${baseUrl}/student/ilamai/viewMyQuizes`, {
      chstudent_id: student_id
    })
      .then((response) => {
        console.log(response.data);
        setQuizzes(response.data.quizes);
      })
      .catch((error) => {
        console.log(error);
      });
  };



  const availableQuizzes = [
    {
      id: 1,
      title: 'React Advanced Study',
      subject: 'Web Development',
      questions: 15,
      duration: 20,
      difficulty: 'easy',
      attempts: 0,
      bestScore: null,
      createdBy: 'John Doe',
      dueDate: '2024-01-10',
      type: 'quiz'
    },
    {
      id: 2,
      title: 'Data Structures & Algorithms',
      subject: 'Computer Science',
      questions: 30,
      duration: 60,
      difficulty: 'Hard',
      attempts: 0,
      bestScore: null,
      createdBy: 'Sarah Smith',
      dueDate: '2024-01-08',
      type: 'test'
    },
    {
      id: 3,
      title: 'Machine Learning Basics',
      subject: 'AI/ML',
      questions: 20,
      duration: 30,
      difficulty: 'Medium',
      attempts: 1,
      bestScore: 78,
      createdBy: 'Mike Johnson',
      dueDate: '2024-01-15',
      type: 'quiz'
    }
  ];


  const handleStartQuiz = (quiz) => {
    generateQuizByIlamai(quiz.title);
    setActiveQuiz(quiz);
    setCurrentQuestion(0);
    setAnswers({});
    setQuizCompleted(false);
    setScore(null);
    setShowQuizModal(true);
  };

  const handleAnswerSelect = (questionIndex, answerIndex) => {
    setAnswers({ ...answers, [questionIndex]: answerIndex });
  };

  const handleNextQuestion = () => {
    if (currentQuestion < sampleQuestions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };



  const handleSubmitQuiz = () => {
    let correctCount = 0;
    sampleQuestions.forEach((question, index) => {
      if (answers[index] === question.correctAnswer) {
        correctCount++;
      }
    });
    const finalScore = Math.round((correctCount / sampleQuestions.length) * 100);
    setScore(finalScore);
    setQuizCompleted(true);
  };

  const handleCloseQuiz = () => {
    if (!quizCompleted) {
      if (window.confirm('Are you sure you want to exit? Your progress will be lost.')) {
        setShowQuizModal(false);
        setActiveQuiz(null);
      }
    } else {
      setShowQuizModal(false);
      setActiveQuiz(null);
    }
  };

  // Create Quiz handlers
  const handleOpenCreateModal = () => {
    setCreateForm({ title: '', subject: '' });
    setCreateError('');
    setShowCreateModal(true);
  };

  const handleCloseCreateModal = () => {
    setShowCreateModal(false);
    setCreateForm({ title: '', subject: '' });
    setCreateError('');
  };

  const handleCreateFormChange = (e) => {
    setCreateForm({ ...createForm, [e.target.name]: e.target.value });
    setCreateError('');
  };

  const handleCreateQuizSubmit = () => {

    const formData = new FormData();
    formData.append("title", createForm.title);
    formData.append("chsubject_id", createForm.subject);
    formData.append("chstudent_id", loggedInStudent?.id);

    axios.post(`${baseUrl}/student/ilamai/createQuiz`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {

        if (response.data.success === "yes") {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Quiz created successfully",
            timer: 1500,
            showConfirmButton: false
          });

          setShowCreateModal(false);
          setCreateForm({ title: "", subject: "" });
          viewMyQuizzes(loggedInStudent?.id);

        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Quiz not created",
          });
        }

      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Server Error",
          text: "Something went wrong",
        });
      });
  };

  const generateQuizByIlamai = (title) => {

    axios.get(`${baseUrl}/student/ilamai/ilamAiGeneratedQuiz/{${title}}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        console.log(response.data);
        const str = response.data;
        const char = "[";
        const charTwo = "]";

        const firstIndex = str.indexOf(char);     // Find first index of ","
        const lastIndex = str.lastIndexOf(charTwo);   // Find last index of ","

        // Extract everything between (and including) the delimiters
        const result = str.slice(firstIndex, lastIndex + 1);
        console.log(result);
        // setSampleQuestions(response.data)
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Server Error",
          text: "Something went wrong",
        });
      });
  };





  useEffect(() => {
    viewAllSubjects();
    const student = JSON.parse(localStorage.getItem("loggedInStudent"));
    viewMyQuizzes(student.id);
    setTimeout(() => {
    }, 1000);

  }, []);

  return (
    <StudentLayout>
      <div className="quizzes-tests">

        {/* Header */}
        <div className="page-header">
          <div className="page-title-section">
            <div className="page-title-icon">📝</div>
            <div>
              <h1 className="page-title">Quizzes & Tests</h1>
              <p className="page-description">Practice and assess your knowledge</p>
            </div>
          </div>

          {/* Create Quiz Button */}
          <button className="btn btn-primary create-quiz-btn" onClick={handleOpenCreateModal}>
            ➕ Create Quiz
          </button>
        </div>


        {/* Tabs */}
        <div className="tabs-container">
          <div className="tabs-header">
            <div
              className={`tab-item ${activeTab === 'available' ? 'active' : ''}`}
              onClick={() => setActiveTab('available')}
            >
              📋 Available
              <span className="tab-badge">{availableQuizzes.length}</span>
            </div>

          </div>

          {/* Available Quizzes */}
          {activeTab === 'available' && (
            <div className="quizzes-grid">
              {quizzes.map(quiz => (
                <div key={quiz.id} className="quiz-card">
                  <div className="quiz-type-badge">
                    {quiz.type === 'test' ? '📄 Test' : '📋 Quiz'}
                  </div>
                  <h3 className="quiz-title">{quiz.title}</h3>
                  <div className="quiz-subject">{quiz.chsubject?.name}</div>
                  <div className="quiz-info">
                    <div className="info-item">
                      <span className="info-icon">❓</span>
                      <span>{quiz.questions} questions</span>
                    </div>
                    <div className="info-item">
                      <span className="info-icon">⏱️</span>
                      <span>{quiz.duration} min</span>
                    </div>

                  </div>

                  <div className="quiz-meta">
                    <span className="meta-item"><span>👤</span>{quiz.createdBy}</span>
                    <span className="meta-item"><span>📅</span>Due: {quiz.dueDate}</span>
                  </div>
                  <button
                    className="btn btn-primary btn-full"
                    onClick={() => handleStartQuiz(quiz)}
                  >
                    {quiz.attempts > 0 ? 'Retake' : 'Start'} {quiz.type === 'test' ? 'Test' : 'Quiz'}
                  </button>
                </div>
              ))}
            </div>
          )}


        </div>

        {/* ===== CREATE QUIZ MODAL ===== */}
        {showCreateModal && (
          <div className="quiz-modal-overlay" onClick={handleCloseCreateModal}>
            <div className="quiz-modal create-modal" onClick={e => e.stopPropagation()}>

              {/* Modal Header */}
              <div className="quiz-modal-header">
                <div className="quiz-modal-title">
                  <h2>➕ Create New Quiz</h2>
                  <p className="modal-subtitle">Fill in the details below to create a new quiz</p>
                </div>
                <button className="modal-close" onClick={handleCloseCreateModal}>✕</button>
              </div>

              {/* Modal Body */}
              <div className="create-modal-body">

                {/* Title Field */}
                <div className="form-group">
                  <label className="form-label">
                    {/* <span className="label-icon">📌</span> */}
                    Quiz Title
                  </label>
                  <input
                    type="text"
                    name="title"
                    value={createForm.title}
                    onChange={handleCreateFormChange}
                    placeholder="e.g. React Hooks Deep Dive"
                    className={`form-input ${createError && !createForm.title.trim() ? 'input-error' : ''}`}
                  />
                </div>

                {/* Subject Dropdown */}
                <div className="form-group">
                  <label className="form-label">
                    <span className="label-icon">📚</span>
                    Subject
                  </label>
                  <select
                    name="subject"
                    value={createForm.subject}
                    onChange={handleCreateFormChange}
                  >
                    <option value="">-- Select Subject --</option>

                    {subjects.map((subject) => (
                      <option key={subject.id} value={subject.id}>
                        {subject.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Error Message */}
                {createError && (
                  <div className="form-error">
                    ⚠️ {createError}
                  </div>
                )}

                {/* Action Buttons */}
                <div className="create-modal-actions">
                  <button className="btn btn-outline" onClick={handleCloseCreateModal}>
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleCreateQuizSubmit}>
                    ✅ Create Quiz
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}

        {/* ===== QUIZ TAKING MODAL ===== */}
        {showQuizModal && !quizCompleted && (
          <div className="quiz-modal-overlay">
            <div className="quiz-modal">
              <div className="quiz-modal-header">
                <div className="quiz-modal-title">
                  <h2>{activeQuiz?.title}</h2>
                  <div className="quiz-progress">
                    Question {currentQuestion + 1} of {sampleQuestions.length}
                  </div>
                </div>
                <button className="modal-close" onClick={handleCloseQuiz}>✕</button>
              </div>

              <div className="quiz-progress-bar">
                <div
                  className="quiz-progress-fill"
                  style={{ width: `${((currentQuestion + 1) / sampleQuestions.length) * 100}%` }}
                />
              </div>

              <div className="quiz-content">
                <div className="question-section">
                  <div className="question-number">Question {currentQuestion + 1}</div>
                  <h3 className="question-text">{sampleQuestions[currentQuestion]?.question}</h3>
                </div>

                <div className="options-section">
                  {sampleQuestions[currentQuestion]?.options.map((option, index) => (
                    <button
                      key={index}
                      className={`option-btn ${answers[currentQuestion] === index ? 'selected' : ''}`}
                      onClick={() => handleAnswerSelect(currentQuestion, index)}
                    >
                      <span className="option-letter">{String.fromCharCode(65 + index)}</span>
                      <span className="option-text">{option}</span>
                    </button>
                  ))}
                </div>

                <div className="question-indicators">
                  {sampleQuestions.map((_, index) => (
                    <button
                      key={index}
                      className={`question-indicator ${answers[index] !== undefined ? 'answered' : ''} ${currentQuestion === index ? 'current' : ''}`}
                      onClick={() => setCurrentQuestion(index)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>

                {currentQuestion === sampleQuestions.length - 1 ? (
                  <button className="btn btn-primary" onClick={handleSubmitQuiz}>Submit Quiz</button>
                ) : (
                  <button className="btn btn-primary" onClick={handleNextQuestion}>Next →</button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ===== RESULTS MODAL ===== */}
        {showQuizModal && quizCompleted && (
          <div className="quiz-modal-overlay">
            <div className="quiz-modal results-modal">
              <div className="results-content">
                <div className="results-icon">
                  {score >= 90 ? '🎉' : score >= 70 ? '👍' : '📚'}
                </div>
                <h2 className="results-title">
                  {score >= 90 ? 'Excellent!' : score >= 70 ? 'Good Job!' : 'Keep Practicing!'}
                </h2>
                <div className="results-stats">
                  <div className="result-stat">
                    <div className="result-stat-label">Correct</div>
                    <div className="result-stat-value correct">
                      {Object.keys(answers).filter(key => answers[key] === sampleQuestions[key].correctAnswer).length}
                    </div>
                  </div>
                  <div className="result-stat">
                    <div className="result-stat-label">Incorrect</div>
                    <div className="result-stat-value incorrect">
                      {Object.keys(answers).filter(key => answers[key] !== sampleQuestions[key].correctAnswer).length}
                    </div>
                  </div>
                  <div className="result-stat">
                    <div className="result-stat-label">Unanswered</div>
                    <div className="result-stat-value unanswered">
                      {sampleQuestions.length - Object.keys(answers).length}
                    </div>
                  </div>
                </div>
                <div className="results-actions">
                  <button className="btn btn-outline" onClick={handleCloseQuiz}>Close</button>
                  <button className="btn btn-primary">Review Answers</button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </StudentLayout>
  );
};

export default QuizzesAndTest;